import {
    createApplicationManagerObject,
    createRemoteLoggerScriptObject,
    createOipfConfigurationObject,
    createBroadcastVideoObject,
    createStyleObject,
    createOipfCapabilitiesObject,
    createMediaSynchroniserObject,
    createHbbTVCSManager,
    createDRMObject
} from './elements-handlers/elements-creator';

import { HBBTV_CONST } from './constants/constants';
import { initKeySet } from './keys/keys';
import { getHbbTvVersion } from './utils/hbbtv-version';
import StorageManager from './storage-manager/storage-manager';
import { HBBTV_KEYS } from './keys/keys-constants';
import WSServer from './companion-screen/ws';
import { discoverCSLaunchers } from './companion-screen/companion-screen';

const storeManager = new StorageManager();
const wsServer = new WSServer();
const drmTmpObject = {};

const initializeHbbTV = (config = { bindToChannel: false, destryAppOnCatch: false }) => {
    return new Promise(async resolve => {
        createStyleObject();
        const applicationManagerObject = createApplicationManagerObject();
        document.body.appendChild(applicationManagerObject);
        const oipfConfiguration = createOipfConfigurationObject();
        document.body.appendChild(oipfConfiguration);
        const broadcastVideo = createBroadcastVideoObject();
        document.body.appendChild(broadcastVideo);
        const oipfCapabilities = createOipfCapabilitiesObject();
        document.body.appendChild(oipfCapabilities);
        const mediaSynchroniser = createMediaSynchroniserObject();
        document.body.appendChild(mediaSynchroniser);
        const hbbtvCSManager = createHbbTVCSManager();
        document.body.appendChild(hbbtvCSManager);
        const drmObject = createDRMObject();
        document.body.appendChild(drmObject);
        if (isHbbTV())
            await initApplication(config.destryAppOnCatch, config.bindToChannel, config.keySet);
        return resolve();
    })
        .catch(e => e);
};

const initApplication = (destryAppOnCatch, bindToChannel, keySet) => {
    let app = document.getElementById(HBBTV_CONST.APP_MNGR_ID);
    if (app && app.getOwnerApplication)
        app = app.getOwnerApplication(document);
    if (app !== null) {
        if (app.show)
            app.show();
        if (app.activate)
            app.activate();
        if (destryAppOnCatch) {
            try {
                let broadcastState = document.getElementById("mainVideoObject").getChannelConfig().channelList;
                if(broadcastState !== undefined){
                    startBroadcastVideo();
                }
            } catch (error) {
                document.getElementById(HBBTV_CONST.APP_MNGR_ID).getOwnerApplication(document).destroyApplication();
            }
        }else{
            if(bindToChannel){
                startBroadcastVideo();
            }
        }
        if (keySet)
            initKeySet(keySet);
        return true;
    }
};

const startBroadcastVideo = () => {
    // setTimeout(() => {
    const mainVideo = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    if (mainVideo.bindToCurrentChannel)
        mainVideo.bindToCurrentChannel();
    mainVideo.onPlayStateChange = (state, error) => {
        if (error)
            console.log('onPlayStateChange error:', error);
        else console.log('onPlayStateChange state:', state);
    };
    if (mainVideo.play)
        mainVideo.play(1);
    // }, 200);
};

const getApplicationManagerObject = () => {
    return document.getElementById(HBBTV_CONST.APP_MNGR_ID);
};

const getOipfConfigurationObject = () => {
    return document.getElementById(HBBTV_CONST.APP_CONF_ID);
};

const getBroadcastVideoObject = () => {
    return document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
};

const setApplicationManagerObjectStyle = (classname) => {
    const obj = document.getElementById(HBBTV_CONST.APP_MNGR_ID);
    obj.className += ` ${classname}`;
};

const setOipfConfigurationObjectStyle = (classname) => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    obj.className += ` ${classname}`;
};

const setBroadcastVideoObjectStyle = (classname) => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    if (obj)
        obj.className += ` ${classname}`;
};

const addApplicationManagerObjectClass = (classname) => {
    const obj = document.getElementById(HBBTV_CONST.APP_MNGR_ID);
    obj.className += ` ${classname}`;
};

const addOipfConfigurationObjectClass = (classname) => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    obj.className += ` ${classname}`;
};

const addBroadcastVideoObjectClass = (classname) => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    if (obj)
        obj.className += ` ${classname}`;
};

const removeApplicationManagerObjectClass = (classname) => {
    const obj = document.getElementById(HBBTV_CONST.APP_MNGR_ID);
    const regex = new RegExp('/(?:^|\s)' + classname + '(?!\S)/g');
    obj.className = obj.className.replace(regex, '');
};

const removeOipfConfigurationObjectClass = (classname) => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    const regex = new RegExp('/(?:^|\s)' + classname + '(?!\S)/g');
    obj.className = obj.className.replace(regex, '');
};

const removeBroadcastVideoObjectClass = (classname) => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    if (obj)
        obj.classList.remove(classname);
};

const getConfiguration = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.configuration)
        return obj.configuration;

    return null;
};

const getLocalSystem = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.localSystem)
        return obj.localSystem;
    return null;
};

const getTunedChannels = (associative = false) => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    const list = obj.getChannelConfig().channelList;
    const toReturn = [];
    [...list].forEach(channel => {
        if (associative) {
            const formattedName = channel.dsd.toLowerCase().split(' ').join('_');
            toReturn[formattedName] = channel;
        } else {
            toReturn.push(channel);
        }
    });

    return toReturn;
};

const jumpToChannel = ({ onid, sid, tsid, quiet = 2 }) => {
    if (!onid || !sid || !tsid)
        throw 'onid, sid or tsid are undefined!';
    if (typeof quiet !== typeof 1)
        throw 'quiet params must be 0, 1 or 2';
    if (quiet !== 0 && quiet !== 1 && quiet !== 2)
        throw 'quiet params must be 0, 1 or 2';

    const broadcast = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    const channel = broadcast.getChannelConfig().channelList.getChannelByTriplet(onid, tsid, sid);
    broadcast.setChannel(channel, false, undefined, quiet);

    //older version below

    // const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    // const list = obj.getChannelConfig().channelList;
    // const targetChannel = list.getChannelByTriplet(onid, tsid, sid);
    // obj.setChannel(targetChannel, false, undefined, quiet);
};

const getLCN = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    const currentChannel = getCurrentChannel();
    if (currentChannel)
        if (currentChannel.majorChannel)
            return currentChannel.majorChannel;
    return null;
};

const createStreamEventListener = (eventName, callback) => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    const currentChannel = obj.currentChannel;
    const channelId = `${currentChannel.onid.toString(16)}.${currentChannel.tsid.toString(16)}.${currentChannel.sid.toString(16)}`;
    const carouselId = "12".toString(16);
    const streamEventURL = `dvb://${channelId}.c/KINE_EVENT`;
    try {
        obj.addStreamEventListener(streamEventURL, 'KINE_EVENT', callback);
    } catch (e) {
        console.log('error on addStreamEventListener', e);
    }
};

const getCurrentChannel = () => {
    const node = document.getElementById(HBBTV_CONST.APP_MNGR_ID);
    if (node && node.getOwnerApplication) {
        const app = node.getOwnerApplication(document);
        return app.privateData.currentChannel;
    }
    return 0;
};

const doOnPlayStateChange = (state, error) => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    switch (state) {
        case 0: // unrealized
            break;
        case 1: // connecting
            break;
        case 2: // presenting
            registerEvents(); //Su alcuni device vanno registrato gli eventi solo quando il listener è pronto (in questo caso)
            // remove listener of doOnPlayStateChange
            obj.onPlayStateChange = () => { };
            break;
        case 3: // stopped
            break;
    }
}

const registerListener = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    if (obj.playState === 2) {
        // if video broadcast object is already in the presenting state add stream event listener
        registerEvents();
    } else {
        // if not wait for the presenting state
        obj.onPlayStateChange = doOnPlayStateChange;
    }
}

const registerEvents = () => {
    try {
        const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
        const currentChannel = obj.currentChannel;
        const channelId = `${currentChannel.onid.toString(16)}.${currentChannel.tsid.toString(16)}.${currentChannel.sid.toString(16)}`;
        const carouselId = "12".toString(16);
        const streamEventURL = `dvb://${channelId}.c/kineevent`;
        obj.addStreamEventListener(streamEventURL, "kineeventname", eventCallback);
    } catch (e) {
        console.log('registerEvents error', e);
    }
}

const eventCallback = (e) => {
    console.log('event fired', e);
};

const stopBroadcastVideo = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    if (obj.stop)
        obj.stop();
    // if (obj.release)
    //     obj.release();
};

const getFormattedUserAgent = () => {
    const userAgent = window.navigator.userAgent;
    let hbbtvVersionMatch = userAgent.match(/HbbTV\/\d\.(\d).(\d)/g);
    if (hbbtvVersionMatch === null)
        hbbtvVersionMatch = 'Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/53.0.2785.34 Safari/537.36 HbbTV/1.4.1 (+DRM+CPAS 2.0.1; LGE; 55SK850V-ZA; WEBOS4.0 03.00.09; W4_M16PP; W4_M16PP;)';
    const hbbtvVersion = hbbtvVersionMatch[0];

    if (hbbtvVersion) {
        const temp = userAgent.substring(userAgent.indexOf(hbbtvVersion) + hbbtvVersion.length);
        const userAgentData = temp.match(/\(([^)]+)\)/)[1];
        if (userAgentData) {
            return userAgentData.split(";");
        }
    }
    return HBBTV_CONST.DEFAULT_USER_AGENT;
}

const setSerialNumber = (localStorageSNName, localStorageSNValue) => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.localSystem && obj.localSystem.serialNumber)
        return;
    storeManager.setItem(localStorageSNName, localStorageSNValue);
};

const getSerialNumber = (localStorageSNName) => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.localSystem)
        return obj.localSystem.serialNumber;
    if (!localStorageSNName)
        return null;
    return storeManager.getItem(localStorageSNName);
};

const getVendorName = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.localSystem && obj.localSystem.vendorName && obj.localSystem.vendorName !== null)
        return obj.localSystem.vendorName;
    const arrayUserAgent = getFormattedUserAgent();
    if (arrayUserAgent && arrayUserAgent.length >= 2) {
        return arrayUserAgent[1];
    }
    return '';
};

const getModelName = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.localSystem)
        return obj.localSystem.modelName;
    const arrayUserAgent = getFormattedUserAgent();
    if (arrayUserAgent && arrayUserAgent.length >= 3) {
        return arrayUserAgent[2];
    }
    return '';
};

const getSoftwareVersion = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.localSystem)
        return obj.localSystem.softwareVersion;

    const arrayUserAgent = getFormattedUserAgent();
    if (arrayUserAgent && arrayUserAgent.length >= 4) {
        return arrayUserAgent[3];
    }
    return '';
};

const getFamilyName = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.localSystem)
        return obj.localSystem.familyName;

    const arrayUserAgent = getFormattedUserAgent();
    if (arrayUserAgent && arrayUserAgent.length >= 6) {
        return arrayUserAgent[5];
    }
    return '';
};

const getMacAddress = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.localSystem && obj.localSystem.networkInterfaces)
        return obj.localSystem.networkInterfaces.macAddress;
    return '';
};

const getGeoInformations = (url) => {
    return fetch(url)
        .then(response => {
            return response.json();
        })
        .then(json => json)
        .catch(err => console.log('err', err))
};

const destroyApplication = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_MNGR_ID);
    if (obj && obj.destroyApplication)
        obj.destroyApplication();
};

const isHbbTV = () => {
    const userAgent = window.navigator.userAgent.toUpperCase();
    if (userAgent.indexOf('HBBTV') >= 0)
        return true;
    return false;
};

const requestAccessToDistinctiveIdentifier = (callback = (data) => { console.log('requestAccessToDistinctiveIdentifier', data) }) => {
    const obj = document.getElementById(HBBTV_CONST.APP_CONF_ID);
    if (obj && obj.requestAccessToDistinctiveIdentifier)
        obj.requestAccessToDistinctiveIdentifier(callback);
    else console.log('requestAccessToDistinctiveIdentifier not available', obj.deviceId)
}

const initMediaSyncroniserObject = (obj = undefined) => {
    // let ms = undefined;
    // const videoBroadcastObject = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_TYPE);
    // const timeline_spec_vba1 = 'urn:dvb:css:timeline:temi:8:1';
    // const timeline_spec_dasha1 = 'urn:dvb:css:timeline:mpd:period:rel:1000:0b71a';
    // if (window.oipfObjectFactory && window.oipfObjectFactory.createMediaSynchroniser)
    //     ms = window.oipfObjectFactory.createMediaSynchroniser();
    // if (!ms) return;
    // ms.initMediaSynchroniser(pip, timeline_spec_vba1);
    // const timestamp_vba1_dasha1 = { 'tlvMaster': 12345, 'tlvOther': 12445 };
    const videoBroadcastObject = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    const ms = document.getElementById(HBBTV_CONST.MEDIA_SYNCHRONISER_ID);
    if (ms && ms.initMediaSynchroniser) {
        if (obj === undefined)
            ms.initMediaSynchroniser(videoBroadcastObject, 'urn:dvb:css:timeline:pts');
        else ms.initMediaSynchroniser(obj, 'urn:dvb:css:timeline:pts');
    }
}

const addMediaToMediaSynchroniser = (media) => {
    const ms = document.getElementById(HBBTV_CONST.MEDIA_SYNCHRONISER_ID);
    const masterCurrentTime = getMediaSynchroniserCurrentTime();
    const timestamp_vba1_dasha1 = { 'tlvMaster': masterCurrentTime, 'tlvOther': masterCurrentTime + 1000 };
    if (ms && ms.addMediaObject)
        ms.addMediaObject(media, 'urn:dvb:css:timeline:pts', timestamp_vba1_dasha1);
}

const getMediaSynchroniserLastError = () => {
    const ms = document.getElementById(HBBTV_CONST.MEDIA_SYNCHRONISER_ID);
    if (ms)
        return { lastError: ms.lastError, lastErrorSource: ms.lastErrorSource }
}

const isPipAvailable = () => {
    const capabilities = document.getElementById(HBBTV_CONST.APP_CAPABILITIES_ID);
    if (capabilities)
        return { extraSDVideoDecodes: capabilities.extraSDVideoDecodes, extraHDVideoDecodes: capabilities.extraHDVideoDecodes }
    return null
};

const getMaxBroadbandStreamsWithBroadcast = () => {
    const ms = document.getElementById(HBBTV_CONST.MEDIA_SYNCHRONISER_ID);
    if (ms)
        return ms.maxBroadbandStreamsWithBroadcast;
};

const getMaxBroadbandStreamsNoBroadcast = () => {
    const ms = document.getElementById(HBBTV_CONST.MEDIA_SYNCHRONISER_ID);
    if (ms)
        return ms.maxBroadbandStreamsNoBroadcast;
}

const getMediaSynchroniserCurrentTime = () => {
    const ms = document.getElementById(HBBTV_CONST.MEDIA_SYNCHRONISER_ID);
    if (ms)
        return ms.currentTime;
    return null;
};

const getTriplet = () => {
    const obj = document.getElementById(HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    if (!obj)
        return [{
            onid: null,
            tsid: null,
            sid: null,
            toString: `null`
        }];
    const currentChannel = obj.currentChannel;
    if (!currentChannel)
        return null;
    return [{
        onid: currentChannel.onid.toString(10),
        tsid: currentChannel.tsid.toString(10),
        sid: currentChannel.sid.toString(10),
        toString: `${currentChannel.onid.toString(10)}.${currentChannel.tsid.toString(10)}.${currentChannel.sid.toString(10)}`
    }];
}

const altair = {
    initializeHbbTV,
    getApplicationManagerObject,
    getOipfConfigurationObject,
    getBroadcastVideoObject,
    setApplicationManagerObjectStyle,
    setOipfConfigurationObjectStyle,
    setBroadcastVideoObjectStyle,
    addApplicationManagerObjectClass,
    addOipfConfigurationObjectClass,
    addBroadcastVideoObjectClass,
    removeApplicationManagerObjectClass,
    removeOipfConfigurationObjectClass,
    removeBroadcastVideoObjectClass,
    getConfiguration,
    getLocalSystem,
    getTunedChannels,
    jumpToChannel,
    createStreamEventListener,
    getHbbTvVersion,
    initKeySet,
    stopBroadcastVideo,
    startBroadcastVideo,
    getCurrentChannel,
    getSerialNumber,
    getVendorName,
    getModelName,
    getSoftwareVersion,
    getFamilyName,
    getMacAddress,
    getGeoInformations,
    setSerialNumber,
    storeManager,
    destroyApplication,
    HBBTV_KEYS,
    isHbbTV,
    isPipAvailable,
    initMediaSyncroniserObject,
    addMediaToMediaSynchroniser,
    getMediaSynchroniserLastError,
    getMaxBroadbandStreamsWithBroadcast,
    getMaxBroadbandStreamsNoBroadcast,
    getMediaSynchroniserCurrentTime,
    requestAccessToDistinctiveIdentifier,
    wsServer,
    discoverCSLaunchers,
    getLCN,
    getTriplet
};

export { altair }